import React from 'react';
import type { MDXRemoteSerializeResult } from 'next-mdx-remote';
import { MDXRemote } from 'next-mdx-remote';
import classnames from 'classnames';

import styles from './Markdown.module.scss';

interface Props {
  className?: string,
  text: MDXRemoteSerializeResult
}

const Markdown = (props: Props) => {
  const {
    className,
    text
  } = props;

  // Hooks

  const [initialText, setInitialText] = React.useState<MDXRemoteSerializeResult>(null);

  React.useEffect(() => {
    if (!initialText && text) {
      setInitialText(text);
    }
  }, [initialText, text]);

  // Empty

  if (!initialText || !initialText.compiledSource) {
    return null;
  }

  // Render

  return (
    <div
      className={classnames(
        styles.root,
        className
      )}
    >
      <MDXRemote {...initialText} />
    </div>
  );
};

export default Markdown;
